export default __webpack_public_path__ + "static/videoGameDesign1-1bbbf70f44ee32b88a7179d001f3deb2.jpg";